// src/patches/quill-nbsp-fix.ts
import Quill from 'quill';

// Define the fix as a module that can be registered
class NbspFix {
  constructor(quill: Quill) {
    const original = (quill as any).getSemanticHTML;

    // Override the getSemanticHTML method to fix the issue with &nbsp;
    (quill as any).getSemanticHTML = function (
      index = 0,
      length?: number
    ): string {
      const len = length ?? this.getLength();
      const html = original.call(this, index, len);
      return html.replace(/&nbsp;|\u00A0/g, ' ');
    };
  }
}

// Register the module with Quill
Quill.register('modules/nbspFix', NbspFix);
